import { ApplicationConfig } from '@angular/core';
import { provideHttpClient } from '@angular/common/http';
import { LuxonDateAdapter } from '@angular/material-luxon-adapter';
import { PreloadAllModules, provideRouter } from '@angular/router';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { withInMemoryScrolling, withPreloading } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';

import { provideFuse } from '@fuse';

import { appRoutes } from 'app/app.routes';
import { mockApiServices } from 'app/mock-api';
import { provideAuth } from 'app/core/auth/auth.provider';
import { provideIcons } from 'app/core/icons/icons.provider';
import { provideTransloco } from 'app/core/transloco/transloco.provider';
import { ProfessionalGateway } from '@domain/gateway/professional-gateway';
import { ProfessionalService } from './infraestructure/professionals/professionals.service';
import { InventoryGateway } from '@domain/gateway/inventory-gateway';
import { InventoryService } from './infraestructure/inventory/inventory.service';
import { CategoriesGateway } from '@domain/gateway/categories-gateway';
import { CategoryService } from './infraestructure/categories/categories.service';
import { TagsGateway } from '@domain/gateway/tags-gateway';
import { TagService } from './infraestructure/tags/tags.service';
import { BrandsGateway } from '@domain/gateway/brands-gateway';
import { BrandService } from './infraestructure/brands/brands.service';
import { OrdersGateway } from '@domain/gateway/orders-gateway';
import { OrdersService } from './infraestructure/orders/orders.service';
import { UsersGateway } from '@domain/gateway/users-gateway';
import { UserService } from './infraestructure/users/users.service';
import { SettingsGateway } from '@domain/gateway/settings-gateway';
import { SettingsService } from './infraestructure/settings/settings.service';

export const appConfig: ApplicationConfig = {
    providers: [
        provideAnimations(),

        provideRouter(
            appRoutes,
            withPreloading(PreloadAllModules),
            withInMemoryScrolling({ scrollPositionRestoration: 'enabled' })
        ),

        // Material Date Adapter
        {
            provide: DateAdapter,
            useClass: LuxonDateAdapter,
        },
        // custom class providers
        {
            provide: ProfessionalGateway,
            useClass: ProfessionalService,
        },
        {
            provide: InventoryGateway,
            useClass: InventoryService,
        },
        {
            provide: CategoriesGateway,
            useClass: CategoryService,
        },
        {
            provide: TagsGateway,
            useClass: TagService,
        },
        {
            provide: BrandsGateway,
            useClass: BrandService,
        },
        {
            provide: OrdersGateway,
            useClass: OrdersService,
        },
        {
            provide: UsersGateway,
            useClass: UserService,
        },
        {
            provide: SettingsGateway,
            useClass: SettingsService,
        },
        {
            provide: MAT_DATE_FORMATS,
            useValue: {
                parse: {
                    dateInput: 'D',
                },
                display: {
                    dateInput: 'DDD',
                    monthYearLabel: 'LLL yyyy',
                    dateA11yLabel: 'DD',
                    monthYearA11yLabel: 'LLLL yyyy',
                },
            },
        },

        // Transloco Config
        provideTransloco(),
        // Auth config
        provideAuth(),
        // Material icons
        provideIcons(),

        // Fuse
        provideFuse({
            mockApi: {
                delay: 0,
                services: mockApiServices,
            },
            fuse: {
                layout: 'thin',
                scheme: 'light',
                screens: {
                    sm: '600px',
                    md: '960px',
                    lg: '1280px',
                    xl: '1440px',
                },
                theme: 'theme-teal',
                themes: [
                    {
                        id: 'theme-default',
                        name: 'Default',
                    },
                    {
                        id: 'theme-brand',
                        name: 'Brand',
                    },
                    {
                        id: 'theme-teal',
                        name: 'Teal',
                    },
                    {
                        id: 'theme-rose',
                        name: 'Rose',
                    },
                    {
                        id: 'theme-purple',
                        name: 'Purple',
                    },
                    {
                        id: 'theme-amber',
                        name: 'Amber',
                    },
                ],
            },
        }),
    ],
};
